import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { HeaderPropsType, isMenuItemDisabled } from 'src/components/Header/Header';
import { dashboardLink, defaultLinks } from 'src/components/Header/Links';
import {
    Container,
    IconLogoutWrapper,
    IconNotificationWrapper,
    IconUserWrapper,
    MainMenuContainer,
    MenuItemWrapper,
    MenuMainFooter,
    PlaybookIconWrapper,
    PlaybookLogo,
    SideMenuContainer,
    UserMenuItemWrapper,
} from 'src/components/Header/LHSMenu/MainMenu.style';
import { SideMenu } from 'src/components/Header/LHSMenu/SideMenu/SideMenu';
import { BrandIcon } from 'src/components/Header/LHSMenu/BrandIcon';
import { NotificationMenu } from './NotificationsMenu/NotificationsMenu';
import { NotificationDot } from './NotificationsMenu/NotificationsMenu.style';
import { NotificationsCentreState } from 'src/components/NotificationsCentre/NotificationsCentreState';
import { SubSectionsMenu } from './SideMenu/MenuSections';
import { useCommon } from 'src/AppState/Common';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';
import { Permission } from 'src/AppState/PermissionGrants/PermissionGrants.types';

export const MainMenu = observer((props: HeaderPropsType): JSX.Element | null => {
    const { onLogoutRequest } = props;
    const { routerBackoffice, notificationsStateNew, permissionGrantsState } = useAppStateContext();
    const common = useCommon();
    const { config } = ConfigState.get(common);

    let linksForView = config.dashboardTab ? [dashboardLink, ...defaultLinks] : defaultLinks;
    const hasBonusEnginePermission = permissionGrantsState.has(Permission.bonusEngineManageBonuses);

    if (config.showBonusEngine === false || hasBonusEnginePermission === false) {
        linksForView = linksForView.filter((link) => link.name !== 'Bonus');
    }

    const onLogoutClick = (e: React.SyntheticEvent): void => {
        e.preventDefault();
        onLogoutRequest();
    };

    const route = routerBackoffice.getValueString('global');

    const notificationsCentreState = NotificationsCentreState.get(common);
    const notificationIsOpen = notificationsStateNew.isOpen;
    const referredPengindNumber = notificationsCentreState.referredPendingNumber;
    const chatPendingNumber = notificationsCentreState.chatPendingNumber;

    const elements = linksForView.map((item) => {
        return (
            <MenuItemWrapper
                isActive={item.route === `global:${route}`}
                key={`${item.name}${item.route}`}
                isDisabled={isMenuItemDisabled(item, permissionGrantsState)}
                route={item.route}
                parameters={item.parameters}
            >
                {item.icon}
                {item.name}
            </MenuItemWrapper>
        );
    });

    return (
        <>
            <SideMenuContainer data-test='main-menu-root'>
                {/* TODO: LOGO REDIRECT TO DASHBOARD */}
                <BrandIcon />

                <MainMenuContainer>
                    <Container>{elements}</Container>
                </MainMenuContainer>

                <MenuMainFooter>
                    <UserMenuItemWrapper
                        isActive={notificationsStateNew.isOpen}
                        onClick={notificationsStateNew.toggleOpen}
                    >
                        <IconNotificationWrapper />
                        Notifications
                        {referredPengindNumber !== 0 || chatPendingNumber !== 0 ? (
                            <NotificationDot isOpen={notificationIsOpen} />
                        ) : null}
                    </UserMenuItemWrapper>
                    {/* TODO: OPEN USER PORTAL */}
                    <UserMenuItemWrapper isActive={false}>
                        <IconUserWrapper />
                        User Portal
                    </UserMenuItemWrapper>
                    <UserMenuItemWrapper
                        onClick={onLogoutClick}
                        data-test='logout-button'
                    >
                        <IconLogoutWrapper />
                        Logout
                    </UserMenuItemWrapper>
                    <PlaybookIconWrapper>
                        <PlaybookLogo />
                        {/* V2.0.0 */}
                    </PlaybookIconWrapper>
                </MenuMainFooter>
            </SideMenuContainer>

            <NotificationMenu isOpen={notificationIsOpen} />
            {route === 'cmsV2' ? <SubSectionsMenu /> : null}
            {props.sideLinks === undefined ? null : <SideMenu sideLinks={props.sideLinks} />}
        </>
    );
});
